import { SgdfNavBar } from './NavBar.js';
window.customElements.define('sgdf-navbar', SgdfNavBar);
//# sourceMappingURL=sgdf-navbar.js.map